<template>
  <div>
    <base-header id="status-header" type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8">
      <!-- Card stats -->
      <div class="row">
        <div class="col-md-3" @click="showModal(1, $event)">
          <stats-card
            id="totalCreditPackage"
            title="Total Credit Packages"
            type="gradient-red"
            :sub-title="totalCreditPackage"
            class="mb-4 mb-xl-0"
          ></stats-card>
        </div>
        <div class="col-md-3" @click="showModal(3, $event)">
          <stats-card
            title="Active Credit Packages"
            type="gradient-red"
            :sub-title="totalActiveCreditPackage"
            class="mb-4 mb-xl-0"
          ></stats-card>
        </div>
        <div class="col-md-3" @click="showModal(4, $event)">
          <stats-card
            title="Inactive Credit Packages"
            type="gradient-red"
            :sub-title="totalInactiveCreditPackage"
            class="mb-4 mb-xl-0"
          ></stats-card>
        </div>
        <div class="col-md-3" @click="showModal(2, $event)">
          <stats-card
            id="totalCreditPackageTransaction"
            title="Transactions"
            type="gradient-orange"
            :sub-title="totalCreditPackageTransaction"
            class="mb-4 mb-xl-0"
          ></stats-card>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--7" v-if="modal.creditPackage == true">
      <div class="row">
        <div class="col">
          <credit-packages-table :status="tableCreditPackageStatus"></credit-packages-table>
        </div>
      </div>
    </div>

    <div class="container-fluid mt--7" v-if="modal.creditPackageTransaction == true">
      <div class="row">
        <div class="col">
          <credit-package-transactions-table></credit-package-transactions-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import CreditPackagesTable from "./Tables/CreditPackagesTable";
import CreditPackageTransactionsTable from "./Tables/CreditPackageTransactionsTable";
import EventBus from "./../event-bus";

export default {
  name: "tables",
  components: {
    CreditPackagesTable,
    CreditPackageTransactionsTable
  },
  data() {
    return {
      totalCreditPackage: "0",
      totalActiveCreditPackage: "0",
      totalInactiveCreditPackage: "0",
      totalCreditPackageTransaction: "0",
      modal: {
        creditPackage: true,
        creditPackageTransaction: false
      },
      tableCreditPackageStatus: "255"
    };
  },
  mounted() {
    EventBus.$on("getTotalPackage", () => {
      this.getTotalCreditPackage("255");
    });
    EventBus.$on("getTotalActivePackage", () => {
      this.getTotalCreditPackage("1");
    });
    EventBus.$on("getTotalInactivePackage", () => {
      this.getTotalCreditPackage("0");
    });

    this.getTotalCreditPackageTransaction();
    this.getTotalCreditPackage("255");
    this.getTotalCreditPackage("1");
    this.getTotalCreditPackage("0");

    $("#totalCreditPackage").addClass("bg-yellow");
  },
  methods: {
    showModal: function(value, event) {
      this.$router.push({ query: { page: 1 } });
      if (value == 1 || value == 3 || value == 4) {
        this.modal.creditPackage = true;
        this.modal.creditPackageTransaction = false;

        if (value == 1) this.tableCreditPackageStatus = "255";
        else if (value == 3) this.tableCreditPackageStatus = "1";
        else if (value == 4) this.tableCreditPackageStatus = "0";
      } else if (value == 2) {
        this.modal.creditPackage = false;
        this.modal.creditPackageTransaction = true;
      }

      var statusCards = $(event.target)
        .closest("#status-header")
        .find("div.card");
      for (var i = 0; i < statusCards.length; i++) {
        $(statusCards[i]).removeClass("bg-yellow");
      }

      $(event.target)
        .closest("div.card")
        .addClass("bg-yellow");
    },

    getTotalCreditPackage(status) {
      this.$store
        .dispatch("fetchTotalCreditPackage", { status: status })
        .then(response => {
          let responseData = response.data;

          if (status == "255") {
            this.totalCreditPackage = responseData;
          } else if (status == "1") {
            this.totalActiveCreditPackage = responseData;
          } else if (status == "0") {
            this.totalInactiveCreditPackage = responseData;
          }
        })
        .catch(e => {
          console.log(e);
        });
    },

    getTotalCreditPackageTransaction() {
      this.$store
        .dispatch("fetchTotalCreditPackageTransaction")
        .then(response => {
          let responseData = response.data;
          this.totalCreditPackageTransaction = responseData;
        })
        .catch(e => {
          console.log(e);
        });
    }
  }
};
</script>
<style></style>
